import React, { FC, useCallback, MouseEvent } from "react";

import { BasicIntegrationCard, IntegrationCardProp } from "./BasicIntegrationCard";

export interface ZapierIntegrationCardProps extends IntegrationCardProp { }

export const ZapierIntegrationCard: FC<ZapierIntegrationCardProps> = (props) => {

    const { checked, disabled, isLinked, isActive, onDisconnect } = props;

    const generateNewWindowClick = useCallback((url: string) => {
        return (e: MouseEvent<HTMLAnchorElement>): boolean => {

            if (url && !disabled) {
                window.open(url, "callout-option", "toolbar=0,status=0,width=1000,height=700");
            }
            // prevent default so the original href doesn't open
            e.preventDefault();
            return false;
        }
    }, [disabled]);

    const generateZapierLink = useCallback(() => {
        return `https://zapier.com/apps/xapp-ai/integrations`
    }, []);

    const handleDisconnectZapier = useCallback(() => {
        if (typeof onDisconnect === "function") {
            onDisconnect();
        }
    }, [onDisconnect]);

    const handleZapierClick = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        if (typeof props.onClick === "function") {
            props.onClick(e);
        }

    }, [props]);

    return (
        <BasicIntegrationCard
            checked={checked}
            disabled={disabled}
            imageUrl="/img/integrations/zapier/zapier-logo.png"
            text="zapier"
            href={generateZapierLink}
            onClick={typeof checked === "boolean" ? handleZapierClick : generateNewWindowClick(generateZapierLink())}
            isLinked={isLinked}
            isActive={isActive}
            onDisconnect={typeof onDisconnect === "function" ? handleDisconnectZapier : undefined}
        />
    )
}